import React from 'react'
import { makeStyles, createStyles, Box } from '@material-ui/core'
const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '&:last-child': {
        marginBottom: 0,
      },
    },
    labelWrapper: {
      '& svg': {
        width: theme.spacing(1.75),
        height: theme.spacing(1.75),
        marginRight: theme.spacing(0.5),
        '& path': {
          fill: theme.palette.grey[800],
        },
      },
    },
  }),
)

const InfoItem = ({ label, value, icon, color, margin, NoJustify, fontSize }) => {
  const classes = useStyles()

  return (
    <Box
      className={classes.root}
      color={color || 'grey.900'}
      lineHeight={1.65}
      alignItems="flex-start"
      display="flex"
      justifyContent={NoJustify ? '' : 'space-between'}
      mb={margin === 'none' ? 0 : 1}
      fontSize={fontSize || 14}
    >
      {label && (
        <Box
          className={classes.labelWrapper}
          color={color || 'grey.800'}
          flexShrink={0}
          mr={1}
          alignItems="center"
          display="flex"
        >
          {icon}
          <Box component="span" fontSize={fontSize || 14}>
            {label}
          </Box>
        </Box>
      )}
      {value}
    </Box>
  )
}

export default InfoItem
